import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

interface AdminProductDraftState {
  filterData: Record<string, any>;
  reloadTableData: boolean;
}

const initialState: AdminProductDraftState = {
  filterData: {},
  reloadTableData: false,
};

const adminProductDraftSlice = createSlice({
  name: 'adminProductDraft',
  initialState,
  reducers: {
    setFilterData(state, action: PayloadAction<Record<string, any>>) {
      state.filterData = { ...state.filterData, ...action.payload };
    },
    resetFilterData(state) {
      state.filterData = {};
    },
    setReloadTableData(state, action: PayloadAction<boolean>) {
      state.reloadTableData = action.payload;
    },
  },
});

export const { setFilterData, resetFilterData, setReloadTableData } =
  adminProductDraftSlice.actions;

export default adminProductDraftSlice.reducer;
